import { render } from "./BookingStep4.vue?vue&type=template&id=0c472a76"
import script from "./BookingStep4.vue?vue&type=script&lang=js"
export * from "./BookingStep4.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/vue/apps/BookingStep4.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0c472a76"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0c472a76', __exports__)) {
    api.reload('0c472a76', __exports__)
  }
  
  module.hot.accept("./BookingStep4.vue?vue&type=template&id=0c472a76", () => {
    api.rerender('0c472a76', render)
  })

}


export default __exports__